import InvestigationalUseDialog from './InvestigationalUseDialog';
import InvestigationalUseDialogWithAutoClick from './InvestigationalUseDialogWithAutoClick';

export default InvestigationalUseDialog;
export { InvestigationalUseDialogWithAutoClick };
